<div *ngIf="showLoading"></div>
<div class="container-blue" *ngIf="!showLoading">
    <img src="../../../../assets/img/logo-iclinic.png" class="logo-iclinic">
    <div class="container-white">
        <img src="../../../../assets/img/ilustra-sessao-expirada.png">
        <h3>Não foi possível acessar o iClinic Pay!</h3>
        <p>Autenticação inválida.</p>
        <button (click)="goBackTo()" class="try-again">Tentar novamente</button>
    </div>
</div>